module.exports = __webpack_public_path__ + "static/media/convoco-logo-inicio.7abe916f.png";